import React from 'react';
import Link from '@rezdy/components/Link';
import TextStyle from '@rezdy/components/TextStyle';
export const TermsAndConditions = () => {
    // eslint-disable-next-line prettier/prettier
    return (
        <TextStyle weight="bold" size="small">
            By creating an account with Rezdy, you agree to our{' '}
            <Link href="https://rezdy.com/terms-of-use/" target="_blank">
                {'terms of use'}
            </Link>
            {' and '}
            <Link href="https://rezdy.com/privacy-policy/" target="_blank">
                {'privacy policy'}
            </Link>
        </TextStyle>
    );
};

export default TermsAndConditions;
